var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useState, useEffect } from 'react';
import { LocationAvatar, useDialogs } from '@michelin/acid-components';
import { useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useTheme from '@material-ui/core/styles/useTheme';
import { useTranslation, CentralProviderContext, } from '../../..';
import CustomerPopup from '../CustomerPopup';
import { getLocationAcidAccountNumbers, getLocationAcidAddress, } from '../utils';
import { isProviderLocation } from '../../../helpers/customers';
import { logger } from '../../../helpers/Log';
import { accountInitializer } from '../AccountInitializer';
var currentDisplayAccountSelector = null;
export function launchAccountSelector() {
    if (!currentDisplayAccountSelector) {
        logger('NO ACCOUNT SELECTOR MOUNTED ON SCREEN!');
        return;
    }
    currentDisplayAccountSelector(true);
}
export var CurrentLocationAvatar = function (props) {
    var t = useTranslation().t;
    var theme = useTheme();
    var dialogs = useDialogs();
    var centralProviderContext = useContext(CentralProviderContext);
    var selectedGrantLocation = centralProviderContext.selectedGrantLocation, selectedGrant = centralProviderContext.selectedGrant;
    var _a = __read(useState(false), 2), displayAccountSelector = _a[0], setDisplayAccountSelector = _a[1];
    var _b = __read(useState(0), 2), forceRender = _b[1];
    var tabletView = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    var openCustomerPopup = function () { return setDisplayAccountSelector(true); };
    var history = useHistory();
    accountInitializer.run(props.disableAutomaticRouting, props.accountSelectorLevels, props.forceAccountSelection, centralProviderContext, history, forceRender);
    useEffect(function () {
        currentDisplayAccountSelector = setDisplayAccountSelector;
        return function () {
            currentDisplayAccountSelector = null;
        };
    }, [setDisplayAccountSelector]);
    if (accountInitializer.shouldDisplayAccountSelector()) {
        centralProviderContext.setSelectingGrant(true);
        return (React.createElement(CustomerPopup, { onClose: function () {
                dialogs.confirmDialog(t('You have not chosen an account, do you want to logout?'), t('Logout'), t('Cancel'), t('Logout'), function () {
                }, function () {
                    centralProviderContext.logout();
                }, { disableBackdropClick: true, disableEscapeKeyDown: true, hideCloseIcon: true });
            }, levels: props.accountSelectorLevels, accountType: props.allowedAccountTypes, custChnlCodes: props.allowedCustChannelCodes, countryCodes: props.allowedCountryCodes, enableStateFiltering: props.enableStateFiltering, alertMessage: accountInitializer.needsToPickAChildLocation()
                ? t('The account type you selected is not currently supported by this application.  Please select a location from the list below to continue.')
                : undefined }));
    }
    if (props.hideAccountAvatar)
        return null;
    if (!accountInitializer.shouldDisplayUserAvatar())
        return null;
    if (!selectedGrantLocation || !selectedGrant)
        return null;
    var role = (selectedGrant.role && selectedGrant.role.name) || '';
    return (React.createElement(React.Fragment, null,
        React.createElement(LocationAvatar, { className: "accountSwitcherLink", variant: "dropdown", name: selectedGrantLocation.customer_dba_name || selectedGrantLocation.customer_name || ' ', role: role, locationType: isProviderLocation(selectedGrantLocation) ? 'dealer' : 'fleet', accountType: selectedGrantLocation.customer_type, accountNumbers: getLocationAcidAccountNumbers(selectedGrantLocation, centralProviderContext.useMdmId), address: getLocationAcidAddress(selectedGrantLocation), displaySwitchAccount: true, onSwitchAccount: openCustomerPopup, avatarOnly: tabletView, header: props.header, footer: props.footer }),
        displayAccountSelector
            ? (React.createElement(CustomerPopup, { onClose: function () { return setTimeout(function () { return setDisplayAccountSelector(false); }, 0); }, levels: props.accountSelectorLevels, accountType: props.allowedAccountTypes, countryCodes: props.allowedCountryCodes, custChnlCodes: props.allowedCustChannelCodes, enableStateFiltering: props.enableStateFiltering }))
            : undefined));
};
//# sourceMappingURL=CurrentLocationAvatar.js.map